<template>
    <div>
        {{ days }}
        <span v-if="still_away" title="Employee is Still Away, No Return Date has been Entered">
            <i class="fa fa-clock-o text-danger"></i>
        </span>
        <template v-if="include_dates">
            (<span v-if="incident[start_date_attr]">{{ incident[start_date_attr] | moment("MM/DD/YYYY") }}</span>
            <span v-if="incident[end_date_attr]"> - {{ incident[end_date_attr] | moment("MM/DD/YYYY") }}</span>)
        </template>
    </div>
</template>

<script>
    import moment from 'moment-timezone';

    export default {
        props: {
            incident: {
                type: Object,
                required: true,
            },

            include_dates: {
                type: Boolean,
                default: true,
            },

            days_attr: {
                type: String,
                required: true,
            },

            start_date_attr: {
                type: String,
                required: true,
            },

            end_date_attr: {
                type: String,
                required: true,
            },
        },

        data() {
            return {

            }
        },

        computed: {
            still_away(){
                if(this.incident[this.start_date_attr] && !this.incident[this.end_date_attr])
                {
                    //SEnd it
                    return true;
                }

                //False
                return false;
            },

            days(){
                //Check if Set
                if(this.incident[this.days_attr])
                {
                    //Send it
                    return this.incident[this.days_attr];
                }

                //If BOTH dates are empty, return empty
                if(!this.incident[this.start_date_attr] && !this.incident[this.end_date_attr])
                {
                    return '';
                }

                //Calculate it
                if(this.still_away)
                {
                    //Setup
                    var start = moment(this.incident[this.start_date_attr]);
                    var now = moment();

                    //Send it
                    return Math.floor(now.diff(start, 'days'));
                }

                //Default
                return '';
            },
        },

        methods: {

        },
    }
</script>
